import { gql } from "@/graphql/typed-gql"

export const GET_DASHBOARD_STATS = gql`
  query GetDashboardStats {
    dashboardStats {
      studentCount
      sessionCount
      completedSessionCount
      recentSessions {
        id
        status
        createdAt
        subjectKey
        exerciseCount
        subject {
          id
          name
        }
        student {
          id
          name
          avatarUrl
        }
      }
    }
  }
`
